import { render } from "./GoodTables.vue?vue&type=template&id=0949911e"
import script from "./GoodTables.vue?vue&type=script&lang=js"
export * from "./GoodTables.vue?vue&type=script&lang=js"

import "./GoodTables.vue?vue&type=style&index=0&id=0949911e&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__